<!-- layout1 6病例实战 -->
<template>
    <div
        class="case-list-section"
    >
      <div class="case-list-section-box" @click="go(dataItem)">
        <div class="case-list-section-left">
          <van-image class="case-list-section-left-img" fit="cover" :src="dataItem.cover_img" />
        </div>
        <div class="case-list-section-right">
          <div class="case-list-section-right-title" v-html="dataItem.title"></div>
          <div class="case-list-section-right-detail" v-if="dataItem.type == 2">
            共{{ dataItem.total_count }}篇
            <span>{{ dataItem.view_count }}人阅读</span>
            <span
                class="case-list-section-right-detail-join"
                v-if="dataItem.is_subscribe === 0"
                @click.stop="attention(dataItem)"
            >
             <img src="static/v4/icon_follow.svg" style="margin-right: 2px"/>关注</span>
            <span v-else class="case-list-section-right-detail-join1" @click.stop="attention(dataItem)">已关注</span>
          </div>
          <div class="case-list-section-right-detail" v-else>
            <span>{{ dataItem.created_at.substr(0,10)}}</span>
            <span>{{ dataItem.view_count }}人阅读</span>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
  name: "case",
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  methods: {
    // 关注/未关注
    attention(item) {
      // is_subscribe 0 未关注  1 已关注
      if (item.is_subscribe == 1) {
        // 取消关注
        this.$dialog
            .confirm({
              title: '提醒',
              message: '确定取消关注吗？',
              confirmButtonText: '确定',
              className: 'dly-dialog'
            })
            .then(() => {
              Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                if (res.code == 0) {
                  this.$toast.success('取消关注成功')
                  content.is_subscribe = 0
                }
              })
            })
            .catch(() => {
              console.log(1)
            })
      } else {
        // 关注
        Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
          if (res.code == 0) {
            this.$toast.success('关注成功')
            content.is_subscribe = 1
          }
        })
      }
    },
    go(item) {
      const pathUrl = item.type === 1 ? 'article-detail' : 'case-column'
      this.$router.push({ name: pathUrl, params: { id: item.origin_id } })
      Interface.mFootPrint(item.origin_id,6,0,5,0, item.title)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/components/case-list-new.scss";
.case-list-section-box{
  width: 355px;
  background: #fff;
  margin: 0 auto;
  border-radius: 8px;
  margin-top: 10px;
}
.case-list-section-left{
  padding-left: 12px;
}
.case-list-section-right{
  padding-right: 12px;
}
.case-list-section-right-detail{
  align-items: center;
}
/deep/ .light {
  color: #D81D20;
}
</style>



// WEBPACK FOOTER //
// src/components/hotRecommend/layout1/case.vue